import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import ReactDOM from 'react-dom';

import Modal from 'components/GeneralComponents/Modal';
import UserCell from './Cell/UserCell';
import StatusCell from './Cell/StatusCell';
import Confirm from './Confirm';
import ConfirmStep2 from './ConfirmStep2';
import constants from '../../constants';
import presenter from '../../duck/presenter';
import styler from '../../duck/styler';
import extractor from '../../duck/extractor';
import './UserTable.scss';
import styled from './styled';
import text from 'strings/text';
import { isNonEmptyString, isValidObject } from 'helpers/validation';
import { Link } from '@material-ui/core';

class UserRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userSelected: false,
      showingTooltip: false,
      toolTipPosition: null,
      toolTipContent: '',
      dropdownPos: null,
      openMenu: false,
      showConfirm: false,
      showConfirmStep2: false,
      selectedAction: null,
    };

    this.apiCalled = false;
    this.calledUsers = [];
    this.initializeRefs();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  initializeRefs() {
    this.openMenuRef = React.createRef();
    this.menuWinRef = React.createRef();
    this.deptRef = React.createRef();
    this.deptRef2 = React.createRef();
    this.groupRef = React.createRef();
    this.groupRef2 = React.createRef();
    this.skillRef = React.createRef();
    this.skillRef2 = React.createRef();
    this.roleRef = React.createRef();
    this.roleRef2 = React.createRef();
    this.userCellRef = React.createRef();
    this.employeeIdRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    this.handleLocationChange(prevProps);
    this.handleSelectedAllUsersChange(prevProps);
    this.handleProcessedUsersChange(prevProps);
    this.handleActionDoneOrCancelledChange(prevProps);
    this.handleFilteredUsersChange(prevProps);
    this.handleMenuStateChange(prevState);
    this.handleProcessingUserIdChange(prevProps);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleLocationChange(prevProps) {
    const { locationId } = this.props;
    if (prevProps.locationId !== locationId) {
      this.calledUsers = [];
      this.apiCalled = false;
    }
  }

  handleSelectedAllUsersChange(prevProps) {
    const { selectedAllUsers, selectedType, selectedIndex, user } = this.props;
    if (prevProps.selectedAllUsers !== selectedAllUsers) {
      const shouldSelect = this.shouldSelectUser(selectedAllUsers, selectedType, selectedIndex, user);
      this.setState({ userSelected: shouldSelect });
    }
  }

  shouldSelectUser(selectedAllUsers, selectedType, selectedIndex, user) {
    if (!selectedAllUsers) return false;
    
    if (selectedType === 'LOCATION') {
      if (selectedIndex === 1) {
        return user && user.status === 'pending';
      } else {
        return user && user.status === 'active';
      }
    }
    
    return user && user.status === 'active';
  }

  handleProcessedUsersChange(prevProps) {
    const { processedUsers, user } = this.props;
    if (prevProps.processedUsers !== processedUsers && processedUsers?.length > 0) {
      const found = processedUsers.filter((id) => id === user.owner_id);
      if (found?.length > 0) {
        this.setState({ userSelected: false });
      }
    }
  }

  handleActionDoneOrCancelledChange(prevProps) {
    const { actionDoneOrCancelled } = this.props;
    if (prevProps.actionDoneOrCancelled !== actionDoneOrCancelled && actionDoneOrCancelled) {
      this.setState({ userSelected: false });
    }
  }

  handleFilteredUsersChange(prevProps) {
    const { filteredUsers } = this.props;
    if (prevProps.filteredUsers !== filteredUsers) {
      if (filteredUsers.length === 0) {
        this.setState({ userSelected: false, openMenu: false });
      } else {
        this.setState({ openMenu: false });
      }
    }
  }

  handleMenuStateChange(prevState) {
    const { openMenu } = this.state;
    if (prevState.openMenu !== openMenu && openMenu) {
      this.calculateDropdownPosition();
    }
  }

  calculateDropdownPosition() {
    const winW2 = '200px';
    const winH2 = '64px';
    const winRight = '40px';
    
    if (this.openMenuRef?.current) {
      const domNode = ReactDOM.findDOMNode(this.openMenuRef.current);
      const output2 = domNode.getBoundingClientRect();
      if (output2) {
        const winTop = `${output2.y - output2.height - 40}px`;
        const winData2 = {
          top: winTop,
          right: winRight,
          width: winW2,
          height: winH2,
        };
        this.setState({ dropdownPos: winData2 });
      }
    }
  }

  handleProcessingUserIdChange(prevProps) {
    const { processingUserId, user } = this.props;
    if (prevProps.processingUserId !== processingUserId && processingUserId === user.id) {
      this.setState({ userSelected: false });
    }
  }

  handleClickOutside = (event) => {
    const { openMenu } = this.state;
    const { notifyMenuOpened } = this.props;

    const isOutsideMenu = this.openMenuRef?.current && !this.openMenuRef.current.contains(event.target);
    const isOutsideMenuWindow = this.menuWinRef?.current && !this.menuWinRef.current.contains(event.target);

    if (isOutsideMenu && isOutsideMenuWindow && openMenu) {
      this.setState({ openMenu: false });
      notifyMenuOpened(false);
    }
  }

  handleSelectUser = (event) => {
    const { user, notifyUserSelected } = this.props;
    const { userSelected } = this.state;

    this.setState({ userSelected: !userSelected });
    notifyUserSelected(user, event.target.checked);
  }

  handleOpenMenuClick = (event) => {
    const { user, notifyMenuOpened, rowMenuOpened } = this.props;
    const { openMenu } = this.state;

    if (rowMenuOpened) {
      if (openMenu) {
        this.setState({ openMenu: !openMenu });
        notifyMenuOpened(!openMenu);
      }
      return;
    }

    if (user && (user.status === 'active' || user.status === 'unregistered')) {
      this.setState({ openMenu: !openMenu });
      notifyMenuOpened(!openMenu);
    }
  }

  handleActionChange = (action) => {
    const { user } = this.props;
    if (user && (user.status === 'active' || user.status === 'unregistered')) {
      this.setState({ openMenu: false, showConfirm: true, selectedAction: action });
    }
  }

  notifyConfirm = (request) => {
    const { selectedAction } = this.state;
    const { user, notifyMenuOpened, notifySingleUserActionRequested } = this.props;
    const { userActionTypes } = constants;

    this.setState({ showConfirm: false });
    notifyMenuOpened(false);

    if (selectedAction.name === userActionTypes.REMOVE && request) {
      this.setState({ showConfirmStep2: true });
    } else {
      this.setState({ userSelected: true });
      notifySingleUserActionRequested(selectedAction.name, user);
    }
  }

  notifyConfirmStep2 = (confirmed) => {
    const { selectedAction } = this.state;
    const { user, notifySingleUserActionRequested } = this.props;
    this.setState({ showConfirmStep2: false, userSelected: true });
    notifySingleUserActionRequested(selectedAction.name, user);
  }

  getActionItems() {
    const { user } = this.props;
    const { userActionTypes } = constants;

    const promote = { name: userActionTypes.PROMOTE, body: text.grantAminPriv };
    const withdraw = { name: userActionTypes.WITHDRAW, body: text.withdrawAdminPriv };
    const remove = { name: userActionTypes.REMOVE, body: text.removeFromLocation };
    const deleteUnregistered = { name: userActionTypes.DELETE_UNREGISTERED, body: text.removeFromLocation };

    if (user?.is_admin) {
      return [withdraw, remove];
    } else if (user?.status === 'unregistered') {
      return [deleteUnregistered];
    } else {
      return [promote, remove];
    }
  }

  renderUserActionMenu = () => {
    const { dropdownPos } = this.state;
    const actionItems = this.getActionItems();

    const actionElements = actionItems.map((item, index) => (
      <div
        key={index}
        className="toolbar__dropdown-item-wrap"
        value={item}
        onClick={() => this.handleActionChange(item)}
      >
        <label className="toolbar__action-dropdown-text">
          {item.body}
        </label>
      </div>
    ));

    if (dropdownPos) {
      return (
        <styled.WinContainerRight 
          ref={this.menuWinRef} 
          top={this.pixelOffsetHack(dropdownPos.top, 30)} 
          right={dropdownPos.right} 
          width={dropdownPos.width} 
          height={dropdownPos.height}
        >
          {actionElements}
        </styled.WinContainerRight>
      );
    }
  }

  pixelOffsetHack(pxString, val) {
    const num = Number(pxString.replace("px", '')) + val;
    return num + 'px';
  }

  userProfileUrl = (user) => {
    const profileUrl = user.status === 'unregistered' ? `unreg/${user.id}` : user.id;
    return 'team/' + profileUrl;
  }

  renderContactField = (user, fieldType) => {
    const content = fieldType === 'phone' 
      ? presenter.getPhoneTooltipContent(user)
      : presenter.getEmailTooltipContent(user);

    if (isValidObject(content) && isNonEmptyString(content)) {
      return content;
    }

    const label = fieldType === 'phone' ? text.userRowAddPhone : text.userRowAddEmail;
    return <Link className='semibold-12' href={this.userProfileUrl(user)}>{label}</Link>;
  }

  mouseLeaveTooltipArea = () => {
    this.setState({ showingTooltip: false, tooltipContent: '' });
  }

  mouseEnterTooltipArea = (itemRef, content, offset) => {
    if (content && content !== '' && content !== null && content !== undefined) {
      this.setState({ 
        toolTipPosition: styler.getToolTipRect(itemRef, offset), 
        showingTooltip: true, 
        toolTipContent: content 
      });
    }
  }

  renderToolTip = () => {
    const { toolTipPosition, toolTipContent } = this.state;
    if (toolTipPosition) {
      return (
        <div style={styler.getToolTipContainerStyle(toolTipPosition)}>
          <div className="mouse-tip__top-wrap">{toolTipContent}</div>
        </div>
      );
    }
  }

  getUserData() {
    const { user, departments, skills, channels, roles, selectedDeptId, selectedType, selectedItem, locationSettings } = this.props;

    const userDepartments = extractor.getUserDepartments(user, departments);
    const userGroups = extractor.getUserGroups(user, channels);
    const userSkills = extractor.getUserSkills(user?.user?.skill_ids, skills);
    const userRoles = extractor.getUserRoles(user, roles);

    const numSkills = userSkills?.length || 0;
    const numDepts = userDepartments?.length || 0;
    const numRoles = userRoles?.length || 0;

    return {
      userDepartments,
      userGroups,
      userSkills,
      userRoles,
      numSkills,
      numDepts,
      numRoles,
      selectedDeptId,
      selectedType,
      selectedItem,
      locationSettings
    };
  }

  getDisplayTexts() {
    const { numSkills, numDepts, numRoles, userGroups } = this.getUserData();

    return {
      admin: text.userRowAdmin,
      teamMember: text.userRowTeamMember,
      none: text.userRowNone,
      userDepartmentText: text.userRowNumDepts(numDepts),
      userSkillsText: text.userRowNumSkills(numSkills),
      userGroupsText: text.userRowNumGroups(userGroups.length),
      userRolesText: text.userRowNumRoles(numRoles)
    };
  }

  getDisplayValues() {
    const { user } = this.props;
    const { userDepartments, userGroups, userSkills, userRoles, selectedDeptId, selectedType, selectedItem, locationSettings } = this.getUserData();
    const { admin, teamMember, none, userDepartmentText, userSkillsText, userGroupsText, userRolesText } = this.getDisplayTexts();

    const isUserActive = user?.status === 'active';
    const isUserPending = user?.status === 'pending';

    // Department display logic
    let userDept = this.getDepartmentDisplay(userDepartments, selectedDeptId, selectedType, userDepartmentText, none, locationSettings);
    
    // Group display logic
    let userGrps = this.getGroupDisplay(userGroups, selectedType, selectedItem, userGroupsText, none);
    
    // Skill display logic
    let userSkls = this.getSkillDisplay(userSkills, selectedType, selectedItem, userSkillsText, none, user, isUserActive);

    // Role display logic
    let userRls = this.getRoleDisplay(userRoles, selectedType, selectedItem, userRolesText, none, user, isUserActive);

    // Handle inactive users
    if (user && user.status !== 'active' && user.status !== 'pending') {
      userDept = none;
      userGrps = none;
      userSkls = none;
      userRls = none;
    }

    return {
      userDept,
      userGrps,
      userSkls,
      userRls,
      userRole: user?.is_admin ? admin : teamMember,
      isUserActive,
      isUserPending
    };
  }

  getDepartmentDisplay(userDepartments, selectedDeptId, selectedType, userDepartmentText, none, locationSettings) {
    if (locationSettings?.cfg__departments !== 1) {
      return none;
    }

    if (selectedType !== 'DEPARTMENTS') {
      return userDepartments?.length > 0 ? userDepartmentText : none;
    }

    if (!userDepartments?.length) {
      return none;
    }

    if (userDepartments.length > 1 && selectedDeptId >= 0) {
      const selectedDept = userDepartments.find(dept => dept.id === selectedDeptId);
      return selectedDept ? selectedDept.name : userDepartments[0].name;
    }

    return userDepartments[0].name;
  }

  getGroupDisplay(userGroups, selectedType, selectedItem, userGroupsText, none) {
    if (selectedType === 'GROUPS') {
      return selectedItem ? selectedItem.name : none;
    }
    return userGroups?.length > 0 ? userGroupsText : none;
  }

  getSkillDisplay(userSkills, selectedType, selectedItem, userSkillsText, none, user, isUserActive) {
    if (selectedType === 'SKILLS' && isUserActive) {
      return selectedItem ? selectedItem.name : none;
    }
    return userSkills?.length > 0 ? userSkillsText : none;
  }

  getRoleDisplay(userRoles, selectedType, selectedItem, userRolesText, none, user, isUserActive) {
    if (selectedType === 'ROLES' && isUserActive) {
      return selectedItem ? selectedItem.name : none;
    }
    return userRoles?.length > 0 ? userRolesText : none;
  }

  getCounts() {
    const { userDepartments, userGroups, userSkills, userRoles } = this.getUserData();
    
    return {
      userDeptCount: userDepartments?.length > 1 ? `+${userDepartments.length - 1}` : '',
      userGroupCount: userGroups?.length > 1 ? `+${userGroups.length - 1}` : '',
      userSkillCount: userSkills?.length > 1 ? `+${userSkills.length - 1}` : '',
      userRoleCount: userRoles?.length > 1 ? `+${userRoles.length - 1}` : ''
    };
  }

  getClassName() {
    const { selectedUsers, user } = this.props;
    
    if (selectedUsers?.length > 0) {
      return selectedUsers[0].status === user.status ? "user-row__row" : "user-row__row-blurred";
    }
    
    return "user-row__row";
  }

  render() {
    const { user, selectedType, handleShowSMSInviteModal, handleEmployeeIDClick } = this.props;
    const { userSelected, openMenu, showConfirm, selectedAction, showConfirmStep2, showingTooltip } = this.state;

    const { userDept, userGrps, userSkls, userRls, userRole, isUserActive, isUserPending } = this.getDisplayValues();
    const { userDeptCount, userGroupCount, userSkillCount, userRoleCount } = this.getCounts();
    const { userDepartments, userGroups, userSkills, userRoles } = this.getUserData();
    const { none } = this.getDisplayTexts();

    const departmentsClassName = userDept === none ? 'user-row__departments-none' : 'user-row__departments';
    const groupsClassName = userGrps === none ? 'user-row__skills-none' : 'user-row__skills';
    const skillsClassName = userSkls === none ? 'user-row__skills-none' : 'user-row__skills';
    const rolesClassName = userRls === none ? 'user-row__skills-none' : 'user-row__skills';
    const notApplicable = '--';

    return (
      <tr className={this.getClassName()}>
        <td className="user-row__checkbox">
          {(isUserActive || isUserPending) && (
            <input
              type="checkbox"
              value={user?.owner_id || ''}
              checked={userSelected}
              onChange={this.handleSelectUser}
            />
          )}
        </td>

        <td 
          className="user-row__owner-cell" 
          ref={this.userCellRef} 
          onMouseEnter={() => this.mouseEnterTooltipArea(this.userCellRef, presenter.getPositionTooltipContent(user), { x: 200, y: 80 })} 
          onMouseLeave={this.mouseLeaveTooltipArea}
        >
          <UserCell user={user} />
        </td>

        <td>
          <div className="user-row_contact-column">
            <span className="contact-label regular-12">{this.renderContactField(user, 'phone')}</span>
            <span className="contact-label regular-12">{this.renderContactField(user, 'email')}</span>
          </div>
        </td>

        <td className="user-row__departments-wrap">
          {!isUserActive && <label className="user-row__skills-none">{notApplicable}</label>}
          {isUserActive && (
            <label
              ref={this.roleRef}
              className={rolesClassName}
              onMouseEnter={() => this.mouseEnterTooltipArea(this.roleRef, presenter.getRoleTooltipContent(userRoles))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userRls}
            </label>
          )}
          {isUserActive && selectedType === 'ROLES' && (
            <label
              ref={this.roleRef2}
              className="user-row__skill-member-count"
              onMouseEnter={() => this.mouseEnterTooltipArea(this.roleRef2, presenter.getRoleTooltipContent(userRoles))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userRoleCount}
            </label>
          )}
        </td>

        <td className="user-row__departments-wrap">
          {!isUserActive && <label className="user-row__skills-none">{notApplicable}</label>}
          {isUserActive && (
            <label
              ref={this.groupRef}
              className={groupsClassName}
              onMouseEnter={() => this.mouseEnterTooltipArea(this.groupRef, presenter.getGroupTooltipContent(userGroups))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userGrps}
            </label>
          )}
          {isUserActive && selectedType === 'GROUPS' && (
            <label
              ref={this.groupRef2}
              className="user-row__group-member-count"
              onMouseEnter={() => this.mouseEnterTooltipArea(this.groupRef2, presenter.getGroupTooltipContent(userGroups))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userGroupCount}
            </label>
          )}
        </td>

        <td className="user-row__departments-wrap">
          {!isUserActive && <label className="user-row__departments-none">{notApplicable}</label>}
          {isUserActive && (
            <label
              ref={this.deptRef}
              className={departmentsClassName}
              onMouseEnter={() => this.mouseEnterTooltipArea(this.deptRef, presenter.getDepartmentTooltipContent(userDepartments))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userDept}
            </label>
          )}
          {isUserActive && selectedType === 'DEPARTMENTS' && (
            <label
              ref={this.deptRef2}
              className="user-row__group-member-count"
              onMouseEnter={() => this.mouseEnterTooltipArea(this.deptRef, presenter.getDepartmentTooltipContent(userDepartments))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userDeptCount}
            </label>
          )}
        </td>

        <td className="user-row__departments-wrap">
          {!isUserActive && <label className="user-row__skills-none">{notApplicable}</label>}
          {isUserActive && (
            <label
              ref={this.skillRef}
              className={skillsClassName}
              onMouseEnter={() => this.mouseEnterTooltipArea(this.skillRef, presenter.getSkillTooltipContent(userSkills))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userSkls}
            </label>
          )}
          {isUserActive && selectedType === 'SKILLS' && (
            <label
              ref={this.skillRef2}
              className="user-row__skill-member-count"
              onMouseEnter={() => this.mouseEnterTooltipArea(this.skillRef2, presenter.getSkillTooltipContent(userSkills))}
              onMouseLeave={this.mouseLeaveTooltipArea}
            >
              {userSkillCount}
            </label>
          )}
        </td>

        <td className="user-row__status-cell">
          <StatusCell user={user} handleShowSMSInviteModal={handleShowSMSInviteModal} />
        </td>

        <td className="user-row__user-role">
          {isUserActive ? userRole : notApplicable}
        </td>

        <td className="user-row__user-role" style={{ cursor: 'pointer' }}>
          <label 
            ref={this.employeeIdRef}
            onMouseEnter={() => this.mouseEnterTooltipArea(this.employeeIdRef, text.userRowEditEmployeeId)}
            onMouseLeave={this.mouseLeaveTooltipArea}
            onClick={() => handleEmployeeIDClick(user)}
          >
            {(user?.status === 'unregistered') ? user.internal_id : (user?.badge_id || '')}
          </label>
        </td>

        <td>
          {user && (user.status === 'active' || user.status === 'unregistered') && (
            <button className="user-row__button-more" ref={this.openMenuRef} onClick={this.handleOpenMenuClick} />
          )}
        </td>

        {openMenu && <Modal>{this.renderUserActionMenu()}</Modal>}
        {showingTooltip && <Modal>{this.renderToolTip()}</Modal>}
        {showConfirm && (
          <Modal>
            <Confirm selectedAction={selectedAction} notifyConfirm={this.notifyConfirm} />
          </Modal>
        )}
        <styled.Overlay display={showConfirm ? 'block' : 'none'} />
        {showConfirmStep2 && (
          <Modal>
            <ConfirmStep2 selectedAction={selectedAction} notifyConfirmStep2={this.notifyConfirmStep2} />
          </Modal>
        )}
      </tr>
    );
  }
}

UserRow.propTypes = {
  notifyUserSelected: PropTypes.func.isRequired,
};

export default injectIntl(UserRow);

